import { render, staticRenderFns } from "./ProcessDocumentUploadTab.vue?vue&type=template&id=875e5430&scoped=true"
import script from "./ProcessDocumentUploadTab.vue?vue&type=script&lang=js"
export * from "./ProcessDocumentUploadTab.vue?vue&type=script&lang=js"
import style0 from "./ProcessDocumentUploadTab.vue?vue&type=style&index=0&id=875e5430&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "875e5430",
  null
  
)

export default component.exports